export default __webpack_public_path__ + "assets/4479e38d38403e50b9e5916163525916.svg";